<div class="container mr-1">
  <app-community-banner (onAddcommunity)="addTodo($event)" (updateFunction)="updateFunction($event)">
  </app-community-banner>
  <div class="hpanel scroll-header business-banner-top">
    <div class="panel-body gs-card-body">
      <div class="col-md-8 d-flex629">
        <h5 class="bus-hov business-name fw-bold-1">Community Page:</h5>
        <div class="business-name break-word ellipse1 rem-1" data-toggle="tooltip" data-placement="top"
          title="{{globalCommunity?.communityBannerDetails?.communityName}}">
          <ng-container *ngIf="globalCommunity?.communityBannerDetails?.communityName!=undefined">
            {{globalCommunity?.communityBannerDetails?.communityName }}
          </ng-container>

          <ng-container *ngIf="globalCommunity?.communityBannerDetails?.tagLine!=undefined && globalCommunity?.communityBannerDetails?.tagLine!=''">
            <span class="opi">|</span>
            <span title="{{ globalCommunity?.communityBannerDetails?.tagLine }}">
              {{ globalCommunity?.communityBannerDetails?.tagLine | truncate: 30 }}
            </span>
          </ng-container>

          <ng-container *ngIf="!globalCommunity?.communityBannerDetails?.communityType">
            <span class="opi">|</span>
            <span class="lkio" (click)="businesBannerData?.members()">
              {{ businesBannerData?.getcount }} Member<span *ngIf="businesBannerData?.getcount > 1">s</span>
            </span>
          </ng-container>

          <ng-container *ngIf="globalCommunity?.communityBannerDetails?.communityType && (businesBannerData?.isJoined === 'true' || businesBannerData?.isAdmin === 'true' || businesBannerData?.isSuperAdmin === 'true')">
            <span class="opi">|</span>
            <span class="lkio" (click)="businesBannerData?.members()">
              {{ businesBannerData?.getcount }} Member<span *ngIf="businesBannerData?.getcount > 1">s</span>
            </span>
          </ng-container>

          <ng-container *ngIf="globalCommunity?.communityBannerDetails?.communityType && businesBannerData?.isJoined === 'false' && businesBannerData?.isAdmin === 'false' && businesBannerData?.isSuperAdmin === 'false'">
            <span class="opi">|</span>
            <span>
              {{ businesBannerData?.getcount }} Member<span *ngIf="businesBannerData?.getcount > 1">s</span>
            </span>
          </ng-container>
        </div>
      </div>
      <div class="col-md-4" style="text-align: right;">
        <button type="button" *ngIf="(businesBannerData?.CisAdmin || businesBannerData?.CisSuperAdmin) && businesBannerData?.viewasmembers " class="btn primary-btn"
          (click)="businesBannerData?.adminview(businesBannerData,true)">
          View as Admin
        </button>
        <button  type="button" *ngIf="(businesBannerData?.CisAdmin || businesBannerData?.CisSuperAdmin) && businesBannerData?.viewasAdmin"
          class="btn primary-btn" (click)="businesBannerData?.viewasmember(businesBannerData ,false)">
          View as Member
        </button>

        <!-- <div *ngIf="!businesBannerData?.Status">
          <button type="button" (click)="businesBannerData?.addJoin()" class="btn primary-btn">
            Join
          </button>
        </div> -->
        <button type="button" *ngIf="
                  !businesBannerData?.CisAdmin &&
                  !businesBannerData?.CisSuperAdmin &&
                  !businesBannerData?.cisJoined &&
                  businesBannerData?.joinStatus == 'REQUEST PENDING'
                " (click)="businesBannerData?.cancelrequest()" class="btn primary-btn">
          Cancel Request
        </button>
        <button type="button" *ngIf="
                  !businesBannerData?.CisAdmin &&
                  !businesBannerData?.CisSuperAdmin &&
                  !businesBannerData?.cisJoined &&
                  businesBannerData?.joinStatus == 'INVITE_REQUEST_RECEVIED'
                " (click)="businesBannerData?.acceptInvite()" class="btn primary-btn ">
          Accept Invite
        </button>
        <button type="button" *ngIf="
                  !businesBannerData?.CisAdmin &&
                  !businesBannerData?.CisSuperAdmin &&
                  !businesBannerData?.cisJoined &&
                  businesBannerData?.joinStatus == 'INVITE_REQUEST_RECEVIED'
                " (click)="businesBannerData?.cancelinvite()" class="btn primary-btn">
          Cancel Invite
        </button>
      </div>
    </div>
  </div>
  <div class="header" >
    <div class="business-page-layout">
      <div class="business-menu">
        <app-navheadercommunity></app-navheadercommunity>
      </div>
      <div class="business-feed">
        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'communityhome'">
          <app-bussiness-post [commonemit]="passdata" [postView]="'COMMUNITY'"></app-bussiness-post>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 p-0  " *ngIf="menu == 'communityabout'">
          <app-community-profile [commonemit]="passdata"></app-community-profile>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'communitypageadmin'">
          <app-community-pageadmin [commonemit]="passdata"></app-community-pageadmin>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'employee'">
          <app-business-employee [commonemit]="passdata"></app-business-employee>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'managepages'">
          <app-managepage [commonemit]="passdata"></app-managepage>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 p-0 " *ngIf="menu == 'memberspage'">
          <app-members [communityData]="businesBannerData"></app-members>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'request'">
          <app-request [commonemit]="passdata"></app-request>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 p-0 " *ngIf="menu == 'Invite'">
          <app-invitesend [commonemit]="passdata"></app-invitesend>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'anayltics'">
          <app-business-analytics [commonemit]="passdata"></app-business-analytics>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12 p-0" *ngIf="menu == 'deactivate'">
          <app-deactivate-community></app-deactivate-community>
        </div>


      </div>
      <div class="business-widget">

        <ng-container *ngIf="menu == 'communityhome' || menu == 'communityabout'">
          <app-common-widget [page]="'COMMUNITY_HOME_PAGE'" [inputData]="'COMMUNITY'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>

        <ng-container *ngIf="menu == 'Invite'">
          <app-common-widget [page]="'COMMUNITY_INVITE_SENT_PAGE'" [inputData]="'COMMUNITY'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="menu == 'request'">
          <app-common-widget [page]="'COMMUNITY_REQUEST_RECEIVED_PAGE'" [inputData]="'COMMUNITY'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="menu == 'communitypageadmin'">
          <app-common-widget [page]="'COMMUNITY_ADMIN_PAGE'" [inputData]="'COMMUNITY'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="menu == 'memberspage'">
          <app-common-widget [page]="'COMMUNITY_MEMBER_PAGE'" [inputData]="'COMMUNITY'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>
        <ng-container *ngIf="menu == 'deactivate'">
          <app-common-widget [page]="'COMMUNITY_DEACTIVATE_PAGE'" [inputData]="'COMMUNITY'" [userType]=userType
            [viewByMember]=adminWidgets>
          </app-common-widget>
        </ng-container>

      </div>
    </div>
  </div>
</div>
